import { image } from '../../utils/helperQuery.wp';

export const navigationFooterQuery = `
    footerMenu: menuItems(where: {location: NAVIGATION_FOOTER}, first: 100) {
        nodes {
            id
            label
            uri
            target
            parentId
            connectedNode {
                node {
                    ... on NodeWithFeaturedImage {
                        featuredImage {
                            ${image}
                        }
                    }
                }
            }
        }
    }
    menuLegal: menuItems(where: {location: NAVIGATION_FOOTER_LEGAL}) {
        nodes {
            id
            label
            uri
            target
            parentId
        }
    }
    menuSocial: menuItems(where: {location: NAVIGATION_FOOTER_SOCIAL}) {
        nodes {
            id
            label
            uri
            target
            parentId
        }
    }
    globalOptionsDefault {
        globalNavigationfooter {
            global_navigationfooter_copyright
            global_navigationfooter_location_heading
            global_navigationfooter_location_link {
                url
                title
                target
            }
            global_navigationfooter_gravity_form_id
            global_navigationfooter_labels {
                socialAriaLabel
                legalAriaLabel
                ariaLabel
            }
        }
    }
    generalSettings {
        title
    }
`;
